// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2dXSk","buttons":"Footer_buttons__3gmuz"};